import React from 'react';

const Logo = ({ className = '', variant = 'default' }) => {
  const sizeClasses = {
    sm: 'h-10',
    default: 'h-16',
    lg: 'h-20',
  };

  const heightClass = sizeClasses[variant] || variant;

  return (
    <img
      src="/images/luse-logo.png"
      alt="LuSE - Lusaka Securities Exchange"
      className={`${heightClass} w-auto object-contain ${className}`}
    />
  );
};

export default Logo;
